import { API_RESPONSE_CODE, API_RESPONSE_KEY } from '../../../api/constants/response'
import { getApi } from '../../../api/utils/get'
import openErrorBannerAction from '../../../banner/actions/open-error'
import getMessageErrorUtil from '../../../error/utils/get-message'
import getJwtSelect from '../../../jwt/selectors/get'
import logSystemUtil from '../../../logs/redux/actions/log'
import deleteRequestNetworkAction from '../../../network/actions/delete-request'
import getCurrentIdProfileSelect from '../../../profile/redux/selectors/get-current-id'
import { getCurrentOrCustomerIdProfileSelect } from '../../../profile/redux/selectors/get-current-or-customer-id'
import createReduxAction from '../../../redux/actions/create'
import setReduxAction from '../../../redux/actions/set'
import REDUX_ACTION from '../../../redux/constants/action'
import { REDUX_MODEL_KEY } from '../../../redux/constants/key'
import REDUX_OPTION from '../../../redux/constants/option'
import REDUX_STATUS from '../../../redux/constants/status'
import { getPathReduxUtil } from '../../../redux/utils/get-path'
import getUpdatedAtReduxUtil from '../../../redux/utils/get-updated-at'
import { getViewedAtReduxUtil } from '../../../redux/utils/get-viewed-at'
import isDeeplyLoadedReduxUtil from '../../../redux/utils/is-deeply-loaded'
import isLoadingReduxUtil from '../../../redux/utils/is-loading'
import isNewReduxUtil from '../../../redux/utils/is-new'
import isSavingReduxUtil from '../../../redux/utils/is-saving'
import { createISOStrDateUtil, differenceInHoursDateUtil, getObjectUtil, isEmptyUtil } from 'packages/src'
import loadSuccessReduxAction from '../../../redux/actions/load/load-success'
import loadErrorReduxAction from '../../../redux/actions/load/load-error'
import loadingReduxAction from '../../../redux/actions/load/loading'
import hasLoadedAssociationsReduxUtil from '../../../redux/utils/has-loaded-associations'

const queryString = require('query-string')

// function shuffleDomainListDataOrderAction ({ domainListPath }) {
//   return (dispatch, getState) => {
//     const domainPath = getDomainPathFromPathReduxUtil(domainListPath)
//     const domainMapPath = getDomainMapDataPathReduxUtil(domainPath)
//     const domainListDataPath = getDomainListDataPathReduxUtil(domainListPath)
//     const domainListIds = getInstanceIdsReduxSelector(
//       domainMapPath,
//       domainListDataPath
//     )(
//       getState())
//     const newDomainListIds = shuffleArrayUtil(domainListIds)
//
//     dispatch(setReduxAction({
//       type: 'REDUX_SHUFFLE_DOMAIN_LIST_DATA_ORDER',
//       payload: {
//         path: domainListDataPath,
//         value: newDomainListIds
//       }
//     }))
//   }
// }

export function loadInstanceReduxAction (action) {
  return async (dispatch, getState) => {
    const { payload } = action
    const {
      data,
      options = {},
      domainListPath
    } = payload

    const profileId = getCurrentOrCustomerIdProfileSelect(getState())
    if (!profileId && !options[REDUX_OPTION.NO_AUTH_NEEDED]) {
      logSystemUtil('loadInstanceReduxAction').warn('no profile')
      return
    }

    const currentProfileId = getCurrentIdProfileSelect(getState())
    let {
      endpoint,
      query = {},
      path
    } = payload

    let instance = getObjectUtil(getState(), path)
    const logPrefix = `path=${path}`
    // if (!path) {
    //   dispatch(deleteRequestNetworkAction(action))
    //   logSystemUtil('loadInstanceReduxAction').warn(`${logPrefix} path not found`)
    //   return
    // }

    const isForced = getObjectUtil(options, REDUX_OPTION.IS_FORCED)
    if (!isForced && !instance && !data) {
      dispatch(deleteRequestNetworkAction(action))
      logSystemUtil('loadInstanceReduxAction').warn(`${logPrefix} not found`)
      return
    }

    const viewedAt = getViewedAtReduxUtil(instance)
    if (!viewedAt || differenceInHoursDateUtil(new Date(), new Date(viewedAt)) > 1) {
      dispatch(setReduxAction({
        type: REDUX_ACTION.UPDATE_VIEWED_AT,
        payload: {
          path: `${getPathReduxUtil(instance)}.${REDUX_MODEL_KEY.VIEWED_AT}`,
          value: createISOStrDateUtil()
        }
      }))
    }

    if (isLoadingReduxUtil(instance) && !isForced) {
      // If it's already loading, no-op
      logSystemUtil('loadInstanceReduxAction').debug(`${logPrefix} [noop] already loading`)
      return
    }

    if (isSavingReduxUtil(instance) && !isForced) {
      // If it's already saving, no-op
      logSystemUtil('loadInstanceReduxAction').debug(`${logPrefix} [noop] it is saving`)
      return
    }

    if (instance && isNewReduxUtil(instance) && !data && !isForced) {
      logSystemUtil('loadInstanceReduxAction').debug(`${logPrefix} [noop] it is new and has no data`)
      return
    }

    if (
      isDeeplyLoadedReduxUtil(instance) &&
      !isForced
    ) {
      // If it's already loaded, no-op
      logSystemUtil('loadInstanceReduxAction').debug(`${logPrefix} [noop] it is already deeply loaded`)
      return
    }

    if (data) {
      if (!path) {
        logSystemUtil('loadInstanceReduxAction').debug('create before load, path is undefined now and will be picked after creation')
      } else {
        logSystemUtil('loadInstanceReduxAction').debug(`${path}: create before load`)
      }
      // If it's an instance that needs to be created then loaded, create it
      const newInstance = dispatch(createReduxAction({
        type: action.type + '_CREATE_BEFORE_LOAD',
        payload: {
          data: {
            data
          },
          path,
          domainListPath
        }
      }))

      if (!path) {
        path = getPathReduxUtil(newInstance)
        logSystemUtil('loadInstanceReduxAction')
          .debug(`${logPrefix} new path is now`)
      }
    }

    logSystemUtil('loadInstanceReduxAction').debug(`${logPrefix} [start]`)
    dispatch(loadingReduxAction({
      type: action.type,
      payload: {
        path
      }
    }))

    let oldPath
    try {
      const jwt = getJwtSelect(getState())
      logSystemUtil('loadInstanceReduxAction').debug(`${logPrefix} [pending]`)

      if (!isNewReduxUtil(instance) &&
        hasLoadedAssociationsReduxUtil(instance) &&
        !query.updatedAt &&
        !getObjectUtil(
          options,
          REDUX_OPTION.IGNORE_UPDATED_AT
        )) {
        query.updatedAt = getUpdatedAtReduxUtil(instance)
      }

      if (!isEmptyUtil(query)) {
        const queryStr = queryString.stringify({
          ...query
        })
        endpoint += `?${queryStr}`
      }

      let fetchOptions
      if (profileId !== currentProfileId) {
        fetchOptions = {
          headers: {
            'x-client-id': profileId
          }
        }
      }
      const response = await getApi({
        endpoint,
        jwt,
        fetchOptions
      })

      if (!response) {
        logSystemUtil('loadInstanceReduxAction').warn('no data for endpoint: ', endpoint)
        return
      }

      logSystemUtil('loadInstanceReduxAction').debug(`path=${path} [done]`)
      const responseData = (
        response.data && Object.values(response.data)[0]
      )

      if (responseData) {
        instance = getObjectUtil(getState(), path)
        const afterLoadInstance = dispatch(
          createReduxAction({
            type: action.type + '_UPDATE_AFTER_LOAD',
            payload: {
              domainListPath,
              data: {
                data: responseData,
                status: REDUX_STATUS.SUCCESS
              },
              existingInstance: instance
            }
          })
        )
        oldPath = path
        path = getPathReduxUtil(afterLoadInstance)
      }

      dispatch(loadSuccessReduxAction({
        type: action.type,
        payload: {
          path,
          oldPath
        }
      }))
      return response
    } catch (error) {
      if (getObjectUtil(error, API_RESPONSE_KEY.STATUS) === API_RESPONSE_CODE.NOT_FOUND) {
        // If the instance was not found show a banner
        dispatch(openErrorBannerAction({
          message: getMessageErrorUtil(error)
        }))
      }
      dispatch(loadErrorReduxAction({
        type: action.type,
        payload: {
          path,
          error,
          oldPath
        }
      }))
      throw error
    }
  }
}
